import {i18n} from '@yourcoach/i18n';

import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

export const getCourseStatusString = (course?: Nullable<CourseApiModel>) => {
  if (!course?.status) {
    return '';
  }

  /**
   * @i18n_parser
   * t('shared:course.status.archived')
   * t('shared:course.status.canceled')
   * t('shared:course.status.ongoing')
   * t('shared:course.status.paused')
   * t('shared:course.status.planned')
   * t('shared:course.status.stopping')
   */
  return i18n.t(`shared:course.status.${course.status}`);
};
